// "Ask Guru" affordance for dashboard cards and tables.
//
// Opens the dock with the question pre-filled and the card's figures
// attached, so "why is this over?" is answered about the number the client
// is looking at. Icon button by default; variant="text" renders a labelled
// button for card footers.
import PropTypes from 'prop-types';
import { Button, IconButton, Tooltip } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

import { openAgentChat } from './openAgentChat';

export default function AskGuruButton({
  prompt,
  clientId,
  parentCompanyId,
  card,
  scope,
  figures,
  send = false,
  variant = 'icon',
  label = 'Ask Guru',
  size = 'small',
  sx,
}) {
  const onClick = (event) => {
    event.stopPropagation();
    openAgentChat({
      prompt,
      clientId,
      parentCompanyId,
      send,
      context: { card, scope, figures },
    });
  };
  const title = `Ask Guru about ${card || 'this'}`;
  if (variant === 'text') {
    return (
      <Button
        size={size}
        startIcon={<SmartToyIcon fontSize="small" />}
        onClick={onClick}
        sx={{ textTransform: 'none', ...sx }}
      >
        {label}
      </Button>
    );
  }
  return (
    <Tooltip title={title}>
      <IconButton size={size} onClick={onClick} aria-label={title} sx={sx}>
        <SmartToyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

AskGuruButton.propTypes = {
  prompt: PropTypes.string,
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  parentCompanyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  card: PropTypes.string,
  scope: PropTypes.object,
  figures: PropTypes.object,
  send: PropTypes.bool,
  variant: PropTypes.oneOf(['icon', 'text']),
  label: PropTypes.string,
  size: PropTypes.string,
  sx: PropTypes.object,
};
